<template>
    <div class="general-form" v-if="customer">
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col cols="8">
                        <b-form-group
                            label="Customer Name"
                            label-class="required-label"
                            description="Please enter Customer Name as per NRIC"
                        >
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true, name: true }"
                                :vid="'customerName'"
                            >
                                <b-form-input
                                    v-model="form.general.name"
                                    type="text"
                                    placeholder="Enter name"
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Date of Birth">
                            <el-date-picker type="date" placeholder="Pick a date" v-model="form.general.dob"
                            value-format="yyyy-MM-dd"
                            ></el-date-picker>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Email Address">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ email: true }"
                                :vid="'email'"
                            >
                                <b-form-input
                                    v-model="form.general.email"
                                    type="email"
                                    placeholder="Enter email"
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Contact No. ">
                            <div class="d-flex justify-content-start">
                                <b-form-input class="col-md-2 mr-1" v-model="form.general.country_code">
                                </b-form-input>
                                <b-form-input
                                    class="col-md-10"
                                    v-model="form.general.contact_no"
                                    type="text"
                                    maxlength="17"
                                    @keydown="preventNonNumericInput"
                                    placeholder="Enter contact number"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Is a Foreigner">
                            <el-radio-group v-model="form.general.is_foreigner">
                                <el-radio-button label="1">Yes</el-radio-button>
                                <el-radio-button label="0">No</el-radio-button>
                            </el-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.general.is_foreigner == 0">
                        <b-form-group label="Customer NRIC">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ number_only: true, nric: true }"
                                :vid="'nric'"
                            >
                                <b-form-input
                                v-model="form.general.nric"
                                type="text"
                                placeholder="Enter nric"
                                maxlength="12"
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.general.is_foreigner == 1">
                        <b-form-group label="Passport">
                            <b-form-input
                            v-model="form.general.passport"
                            type="text"
                            placeholder="Enter passport"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.general.is_foreigner == 1">
                        <b-form-group label="Foreign IC">
                            <b-form-input
                            v-model="form.general.foreign_ic"
                            type="text"
                            placeholder="Enter Foreign IC"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Gender">
                            <el-radio-group v-model="form.general.gender">
                                <el-radio-button label="Male"></el-radio-button>
                                <el-radio-button label="Female"></el-radio-button>
                            </el-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Marital Status">
                            <el-radio-group v-model="form.general.marital_status">
                                <el-radio :label="'Single'">Single</el-radio>
                                <el-radio :label="'Married'">Married</el-radio>
                            </el-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.general.marital_status === 'Married'">
                        <b-form-group label="Spouse Employment Status">
                            <el-radio-group v-model="form.general.spouse_employment_status">
                                <el-radio :label="'Employed'">Employed</el-radio>
                                <el-radio :label="'Unemployed'">Unemployed</el-radio>
                            </el-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="form.general.marital_status === 'Married' && form.general.spouse_employment_status === 'Employed'">
                        <b-form-group
                            label="Spouse Income"
                        >
                            <b-form-input
                            v-model="form.general.spouse_income"
                            type="number"
                            placeholder="Enter Spouse Income"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6" v-if="form.general.marital_status === 'Married'">
                        <b-form-group
                            v-for="(child, index) in form.childrens"
                            :key="child.key"
                            :label="'Child ' + `${index + 1}`"
                            label-cols="5" label-cols-md="3"
                        >
                            <div class="d-flex align-items-center">
                                    <b-form-input v-model="child.age" placeholder="Enter Age"></b-form-input>
                            
                                    <el-button 
                                        @click.prevent="removeChild(child)" 
                                        type="danger" 
                                        icon="el-icon-close" 
                                        size="mini" 
                                        circle 
                                        class="mx-2"
                                    ></el-button>
                            </div>
                        </b-form-group>
                        <b-button @click="addChild" block variant="outline-primary" class="my-3">+ Add</b-button>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Race">
                            <el-radio-group v-model="form.general.race">
                                <el-radio-button label="Chinese"></el-radio-button>
                                <el-radio-button label="Malay"></el-radio-button>
                                <el-radio-button label="Indian"></el-radio-button>
                                <el-radio-button label="Others"></el-radio-button>
                            </el-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Country of Birth">
                            <el-select v-model="form.general.cob_id" placeholder="Select">
                                <el-option
                                v-for="item in tables.countries"
                                :key="item.country_id"
                                :label="item.name"
                                :value="item.country_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Nationality">
                            <el-select v-model="form.general.nationality_id" placeholder="Select">
                                <el-option
                                v-for="item in tables.nationalities"
                                :key="item.nationality_id"
                                :label="item.name"
                                :value="item.nationality_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group
                            label="Address"
                            description="*Please fill NRIC Address"
                        >
                            <b-form-input
                            v-model="form.location1.address_1"
                            type="text"
                            placeholder="Enter address"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12">
                        <b-row>
                            <b-col md="4" cols="12">
                                <b-form-group label="States">
                                    <el-select v-model="form.location1.state_id" placeholder="Select">
                                        <el-option :value="null"></el-option>
                                        <el-option
                                        v-for="item in tables.states"
                                        :key="item.state_id"
                                        :label="item.name"
                                        :value="item.state_id">
                                        </el-option>
                                    </el-select>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="City">
                                    <b-form-input
                                    v-model="form.location1.city"
                                    type="text"
                                    placeholder="Enter city"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group label="Postcode">
                                    <ValidationProvider
                                        v-slot="{ errors }"
                                        :rules="{ postcode: true }"
                                        :vid="'postcode'"
                                    >
                                        <b-form-input
                                        v-model="form.location1.postcode"
                                        type="text"
                                        placeholder="Enter postcode"
                                        ></b-form-input>
                                        <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col cols="12">
                        <b-form-group>
                            <el-checkbox v-model="has_diff_residential"></el-checkbox>
                            <span class="ml-1">Current Residential Address is different from NRIC</span>
                        </b-form-group>
                    </b-col>

                    <div v-if="has_diff_residential">
                        <b-col cols="8">
                            <b-form-group
                                label="Address"
                                description="*Please fill Residential Address"
                            >
                                <b-form-input
                                v-model="form.location2.address_1"
                                type="text"
                                placeholder="Enter address"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
    
                        <b-col cols="12">
                            <b-row>
                                <b-col md="4" cols="12">
                                    <b-form-group label="States">
                                        <el-select v-model="form.location2.state_id" placeholder="Select">
                                            <el-option :value="null"></el-option>
                                            <el-option
                                            v-for="item in tables.states"
                                            :key="item.state_id"
                                            :label="item.name"
                                            :value="item.state_id">
                                            </el-option>
                                        </el-select>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group label="City">
                                        <b-form-input
                                        v-model="form.location2.city"
                                        type="text"
                                        placeholder="Enter city"
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group label="Postcode">
                                        <ValidationProvider
                                            v-slot="{ errors }"
                                            :rules="{ postcode: true }"
                                            :vid="'postcode'"
                                        >
                                            <b-form-input
                                            v-model="form.location2.postcode"
                                            type="text"
                                            placeholder="Enter postcode"
                                            ></b-form-input>
                                            <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                    </ValidationProvider>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </div>

                    <b-col cols="8">
                        <b-form-group label="Length of Stay (Year)">
                            <b-form-input
                            v-model="form.general.length_of_stay"
                            type="number"
                            placeholder="Enter Length of Stay"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="8">
                        <b-form-group label="Education Level">
                            <el-select v-model="form.general.education_id" placeholder="Select">
                                <el-option
                                v-for="item in tables.educations"
                                :key="item.education_id"
                                :label="item.name"
                                :value="item.education_id">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-form-group label="Mother's Maiden Name">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ name: true }"
                                :vid="'maidenName'"
                            >
                                <b-form-input
                                v-model="form.general.mothers_maiden_name"
                                type="text"
                                placeholder="Enter mother's maiden name"
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" @click.prevent="update()">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { DatePicker, Radio, RadioGroup, RadioButton, Select, Option, Checkbox, Button } from 'element-ui'
import {
notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

    export default {
        name: 'general-form',
        props: ['customer', 'tables'],
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        components: {
            ValidationObserver,
            ValidationProvider,
            [DatePicker.name]: DatePicker,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Select.name]: Select,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
        },
        data() {
            const nricLocation = this.customer.locations.nric || {}
            const residentialLocation = this.customer.locations.residential || {}

            return {
                has_diff_residential: this.customer.locations.residential !== null ? true:false,
                form: {
                    childrens: this.customer.childrens,
                    general:{
                        name: this.customer.name,
                        dob: this.customer.dob,
                        nric: this.customer.nric,
                        email: this.customer.email,
                        country_code: this.customer.country_code ?? '+60',
                        contact_no: this.customer.contact_no,
                        gender: this.customer.gender,
                        cob_id: this.customer.cob_id,
                        race: this.customer.race,
                        marital_status: this.customer.marital_status,
                        nationality_id: this.customer.nationality_id,
                        length_of_stay: this.customer.length_of_stay,
                        mothers_maiden_name: this.customer.mothers_maiden_name,
                        education_id: this.customer.education_id,
                        spouse_employment_status: this.customer.spouse_employment_status ?? null,
                        spouse_income: this.customer.spouse_income ?? null,
                        is_foreigner: this.customer.is_foreigner ?? null,
                        foreign_ic: this.customer.foreign_ic ?? null,
                        passport: this.customer.passport ?? null,
                    },
                    location1: {
                        customer_location_id: nricLocation.customer_location_id ?? null,
                        customer_id: this.customer.customer_id,
                        address_1: nricLocation.address_1 ?? null,
                        state_id: nricLocation.state_id ?? null,
                        city: nricLocation.city ?? null,
                        postcode: nricLocation.postcode ?? null,
                        country_id: nricLocation.country_id ?? 1,
                        type: 'nric',
                    },
                    location2: {
                        customer_location_id: residentialLocation.customer_location_id ?? null,
                        customer_id: this.customer.customer_id,
                        address_1: residentialLocation.address_1 ?? null,
                        state_id: residentialLocation.state_id ?? null,
                        city: residentialLocation.city ?? null,
                        postcode: residentialLocation.postcode ?? null,
                        country_id: residentialLocation.country_id ?? 1,
                        type: 'residential',
                    },
                },
            }
        },
        watch:{
            customer(newVal, oldVal){
                if (newVal){
                    const nricLocation = newVal.locations.nric || {}
                    const residentialLocation = newVal.locations.residential || {}
    
                    this.form.location1.customer_location_id = nricLocation.customer_location_id
                    this.form.location2.customer_location_id = residentialLocation.customer_location_id

                    this.form.childrens = newVal.childrens
                    this.form.general.dob = newVal.dob
                }
            }
        },
        methods:{
            ...mapActions(useCustomerStore,['getCustomer']),
            update(){
                let calls = [
                    this.updateCustomerGeneralInfo(),
                    this.updateCustomerChildrens()
                ]
                if(
                    this.form.location1.address_1 || 
                    this.form.location1.state_id || 
                    this.form.location1.city ||
                    this.form.location1.postcode
                ){
                    calls.push(this.updateCustomerLocation())
                }

                Promise.all(calls)
                .then(responses  => {
                        this.notifySuccess('<b>Customer: '+responses[0].data.data.name+'</b> - Successfully Updated.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            updateCustomerGeneralInfo(){
                return axios.put(services.customer + 'customers/' + this.customer.customer_id, this.form.general, {headers: getHeader()})
            },
            updateCustomerLocation(){
                let locations = [this.form.location1]

                if(this.has_diff_residential){
                    locations.push(this.form.location2)
                }

                return axios.post(services.customer + 'customer/'+this.customer.customer_id+'/locations', {
                    locations:locations,
                }, {headers: getHeader()})
            },
            updateCustomerChildrens(){
                return axios.post(services.customer + 'customer/' + this.customer.customer_id+ '/childrens', {childrens:this.form.childrens}, {headers: getHeader()})
            },
            removeChild(item) {
                if(this.form.childrens.length > 0){
                    var index = this.form.childrens.indexOf(item);
                    this.form.childrens.splice(index, 1);
                }
            },
            addChild() {
                this.form.childrens.push({age: null});
            },
            preventNonNumericInput(event) {
                const keyCode = event.keyCode || event.which;
                const keyValue = String.fromCharCode(keyCode);
                const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
                const allowedKeys = [8, 37, 38, 39, 40, 46];
                if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                    event.preventDefault();
                }
            },
        },
        
    }
</script>